import { render } from "./UserGuide.vue?vue&type=template&id=86450624&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"

import "./UserGuide.vue?vue&type=style&index=0&id=86450624&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86450624"]])

export default __exports__